import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["platformCheckbox", "submitBtn", "loading", "results"]
  static values = { url: String }

  async submit(event) {
    event.preventDefault()

    const selected = this.platformCheckboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)

    if (selected.length === 0) {
      alert("Select at least one platform.")
      return
    }

    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.textContent = "Repurposing..."
    if (this.hasLoadingTarget) this.loadingTarget.classList.remove("hidden")
    if (this.hasResultsTarget) this.resultsTarget.classList.add("hidden")

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "application/json"
        },
        body: JSON.stringify({ target_platforms: selected })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        this.showSuccess(data)
      } else {
        this.showError(data.error || "Failed to repurpose content.")
      }
    } catch (error) {
      this.showError("Network error. Please try again.")
    } finally {
      if (this.hasLoadingTarget) this.loadingTarget.classList.add("hidden")
      this.submitBtnTarget.disabled = false
      this.submitBtnTarget.textContent = "Repurpose Content"
    }
  }

  showSuccess(data) {
    if (!this.hasResultsTarget) return

    const links = data.items.map(item =>
      `<a href="${this.escapeAttr(item.url)}" class="inline-flex items-center px-2.5 py-1 text-xs font-medium text-[#C4A484] border border-[#C4A484] rounded-full hover:bg-[#C4A484] hover:text-white transition-colors">
        ${this.escapeHtml(item.platform.charAt(0).toUpperCase() + item.platform.slice(1))} Draft
      </a>`
    ).join("")

    this.resultsTarget.innerHTML = `
      <div class="p-3 bg-[#9CAF88]/10 border border-[#9CAF88]/20 rounded-lg">
        <p class="text-xs text-[#9CAF88] mb-2">${this.escapeHtml(data.message)}</p>
        <div class="flex flex-wrap gap-2">${links}</div>
      </div>
    `
    this.resultsTarget.classList.remove("hidden")

    // Uncheck all checkboxes
    this.platformCheckboxTargets.forEach(cb => { cb.checked = false })
  }

  showError(message) {
    if (!this.hasResultsTarget) return

    this.resultsTarget.innerHTML = `
      <div class="p-3 bg-[#E57373]/10 border border-[#E57373]/20 rounded-lg">
        <p class="text-xs text-[#E57373]">${this.escapeHtml(message)}</p>
      </div>
    `
    this.resultsTarget.classList.remove("hidden")
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text || ""
    return div.innerHTML
  }

  escapeAttr(text) {
    return (text || "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  }
}
